import React from 'react';
import { Link, Outlet } from 'react-router-dom';
import { ROUTES } from '@/routes';
import { Logo } from '@/components';
import { useLiquidGlass } from '@/hooks';
import { FORM_GLASS_SETTINGS } from '@/constants';
import styles from './AuthLayout.module.scss';

interface AuthLayoutProps {
  children?: React.ReactNode;
}

/**
 * Centered auth shell — logo, then the form, centered together in the
 * viewport, with a copyright line pinned to the bottom.
 */
export const AuthLayout: React.FC<AuthLayoutProps> = ({ children }) => {
  const glassRef = useLiquidGlass<HTMLDivElement>(FORM_GLASS_SETTINGS);

  return (
    <div className={styles.page}>
      <div className={styles.bgwrap} aria-hidden="true">
        <span className={styles.grain} />
      </div>

      <div className={styles.center}>
        <Link to={ROUTES.LOGIN} className={styles.brand} aria-label="EvalTick">
          <Logo mode="light" />
        </Link>

        <div ref={glassRef} className={styles.form}>
          {children || <Outlet />}
        </div>

        <p className={styles.legal}>
          By signing in, you agree to the EvalTick{' '}
          <a
            href="https://evaltick.ca/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.legalLink}
          >
            Privacy Policy
          </a>
        </p>
      </div>

      <p className={styles.lfoot}>© 2026 • EVALTICK</p>
    </div>
  );
};

export default AuthLayout;
